
import React, { useState, useEffect, useRef } from 'react';
import HubspotForm from 'react-hubspot-form';

const LazyHubspotForm = ({ portalId, formId, onSubmit, onReady, loading }) => {
  const [inView, setInView] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '200px', // Load the form when it's 200px away from the viewport
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div ref={ref} style={inView ? undefined : { minHeight: '400px' }}>
      {inView ? (
        <HubspotForm
          portalId={portalId}
          formId={formId}
          onSubmit={onSubmit}
          onReady={onReady}
          loading={loading}
        />
      ) : (
        <div>{loading}</div>
      )}
    </div>
  );
};

export default LazyHubspotForm;

